module.exports = __webpack_public_path__ + "img/map-photopoints-preview.4a1fa8c2.png";